<template>
  <div>
    <div id="headerTop">
      <div 
        id="comparar"
        v-on:click="comparar"
        v-on:hover="listarComparacoes"
      >
       <icon-base icon-name="compare"><icon-compare /></icon-base>

        COMPARAR ({{ comparacoes }})
      </div>
      <span id="boasVindas">{{ msg }}</span>
      <nav id="topLinks">
        <ul>
          <li><a href="customer/account" id="minhaConta" rel="noopener">MINHA CONTA</a></li>
          <li><a href="wishlist" id="meusFavoritos" rel="noopener">MEUS FAVORITOS</a></li>
          <li><a href="account/login" id="entrar" rel="noopener">ENTRAR</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
  import IconBase from './IconBase';
  import IconCompare from './icons/IconCompare';

  const components = {
    IconBase,
    IconCompare
  }

  const props = {
    msg: String
  }

  const methods = {
    comparar() {
      console.log("comparar");
    },
    listarComparacoes() {
      console.log("listarComparacoes")
    }
  }

  const computed = {
    comparacoes() {
      return this.$store.getters.comparacoes
    },
  }

  export default {
    name: 'HeaderTop',
    props,
    methods,
    computed,
    components
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #headerTop {
    color: #fff;
    background-color: #008acc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
  }

  #comparar {
    cursor: pointer;
  }

  a {
    color: #fff;
    background-color: #008acc;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  ul {
    display: flex;
    justify-content: space-between;
    list-style-type: none;
    align-items: center;
  }

  li {
    margin: 0 1rem;
  }
</style>
